import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeComponent } from './theme.component';
import { ThemeRoutingModule } from './theme-routing.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { EpTableComponent, ViewCardComponent } from '@ep/shared';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { PanelModule } from 'primeng/panel';

@NgModule({
  declarations: [ThemeComponent],
  imports: [
    AccordionModule,
    CommonModule,
    ThemeRoutingModule,
    ColorPickerModule,
    EpTableComponent,
    CardModule,
    ButtonModule,
    DividerModule,
    FaIconComponent,
    TieredMenuModule,
    FormsModule,
    TabViewModule,
    ViewCardComponent,
    PanelModule,
  ],
})
export class ThemeModule {}
